module.exports = __webpack_public_path__ + "img/b0309_12.98781351.png";